// Experience Section Data – Work (Palestine) + Conferences
import { SectionHeader, ExperienceItem, ConferenceItem } from './schemas';

export const experienceData = {
  header: new SectionHeader("My Journey", "Professional Experience", "experience"),

  experiences: [
    new ExperienceItem(
      "Software Engineer",
      "QuizPlus Company",
      [
        "Developed cross-platform mobile applications using React Native and Flutter",
        "Collaborated with cross-functional teams to deliver high-quality products",
        "Implemented responsive UI/UX designs and optimized app performance",
        "Maintained and updated existing applications with new features"
      ],
      "FaMobileAlt",
      "2023-12",
      null,
      "https://quizplus.com/"
    ),
    new ExperienceItem(
      "Program Coordinator",
      "Gaza Sky Geeks - Mercy Corps",
      [
        "Coordinated tech training programs and educational initiatives",
        "Managed program logistics and participant engagement",
        "Facilitated workshops and mentorship programs for aspiring developers",
        "Collaborated with international partners and local tech communities"
      ],
      "FaProjectDiagram",
      "2024-08",
      null,
      "https://gazaskygeeks.com/"
    ),
    new ExperienceItem(
      "JavaScript Student Trainer",
      "Educational Institution",
      [
        "Conducted JavaScript training sessions for students",
        "Developed curriculum and learning materials",
        "Provided mentorship and technical guidance to learners",
        "Assessed student progress and provided constructive feedback"
      ],
      "FaChalkboardTeacher",
      "2023-04",
      "2023-11",
      null
    ),
    new ExperienceItem(
      "Software Development Intern",
      "Tech Companies",
      [
        "Gained hands-on experience in software development lifecycle",
        "Worked on real-world projects under professional supervision",
        "Learned industry best practices and development methodologies",
        "Collaborated with senior developers and contributed to team projects"
      ],
      "FaCode",
      "2020-06",
      "2021-08",
      null
    ),
    new ExperienceItem(
      "IEEE Leadership",
      "IEEE Student Branch",
      [
        "Served as Vice Chair, leading technical initiatives and events",
        "Acted as Treasurer, managing chapter finances and budgets",
        "Organized workshops, seminars, and networking events",
        "Mentored junior members and promoted professional development"
      ],
      "FaUsers",
      "2022-09",
      "2023-06",
      null
    )
  ],

  conferences: [
    new ConferenceItem(
      "ACPC",
      "2024-12",
      "Luxor, Egypt",
      "",
      "Arab Collegiate Programming Contest – December 2024."
    ),
    new ConferenceItem(
      "Expand Conference",
      "2025-10",
      "Amman, Jordan",
      "",
      "Expand Conference – October 2025."
    ),
    new ConferenceItem(
      "Poker Gamers Connect",
      "2025-11",
      "Aqaba, Jordan",
      "",
      "Poker Gamers Connect – November 2025."
    )
  ],

  summary: {
    title: "Career Highlights",
    content: "My professional journey showcases a unique combination of technical development skills and program management expertise. From hands-on mobile development to leading educational initiatives, I've consistently focused on delivering impactful solutions and fostering community growth."
  }
};
